export const CATEGORIA_LABELS = {
    'DESPESA_FIXA': 'Despesa Fixa',
    'COMPRA_NACIONAL': 'Compra Nacional',
    'DESPESA_VARIAVEL': 'Despesa Variável',
    'IMPOSTO': 'Imposto',
    'PESSOAL': 'Pessoal',
    'INVESTIMENTO': 'Investimento',
    'OUTROS': 'Outros'
};

export const SUBCATEGORIA_LABELS = {
    'OPERACIONAL': 'Operacional',
    'SISTEMAS': 'Sistemas',
    'ASSESSORIAS': 'Assessorias',
    'ALIMENTACAO': 'Alimentação',
    'LIMPEZA': 'Limpeza',
    'SEGURANCA': 'Segurança',
    'EXTRAS': 'Extras',
    'PLATAFORMAS_ADS_FULL': 'Ads / Plataformas'
};

export const STATUS_LABELS = {
    'PAGO': 'Pago',
    'PENDENTE': 'Pendente',
    'CANCELADO': 'Cancelado'
};

export const FORMA_PAGAMENTO_LABELS = {
    'A_VISTA': 'À Vista',
    'PARCELADO': 'Parcelado'
};

export const MESES_NOMES = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];
